import { Spin } from 'antd';
import { type ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { checkPermission } from 'utils/utils';

type Props = { children: ReactNode };

/** Blocks /draft-medicines-request when user lacks DraftMedicinesRequest view. */
export const DraftMedicinesRequestRouteGate = ({ children }: Props) => {
	const isProfileLoading = useSelector(
		(state: any) => state?.userProfile?.isLoading,
	);
	const permissions = useSelector((state: any) => state?.userProfile?.data?.permissions);

	if (isProfileLoading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
				<Spin size="large" />
			</div>
		);
	}

	const canAccess = checkPermission(permissions, {
		permissionName: 'DraftMedicinesRequest',
		permission: ['view', 'viewAll'],
	});

	if (!canAccess) {
		return <Navigate to="/access-denied" replace />;
	}

	return <>{children}</>;
};
